module.exports = __webpack_public_path__ + "static/media/equalicare-img06.4f10caf9.png";